const PENDING_EVENT_PATH_KEY = 'pendingEventPath';
const EVENT_PATH_PATTERN = /^\/event\/([1-9]\d*)$/;

export const parseEventId = (eventId: string | undefined): number | null => {
  if (!eventId || !/^[1-9]\d*$/.test(eventId)) {
    return null;
  }

  const parsedEventId = Number(eventId);
  return Number.isSafeInteger(parsedEventId) ? parsedEventId : null;
};

export const isValidEventPath = (path: string): boolean => {
  const match = EVENT_PATH_PATTERN.exec(path);
  return !!match && parseEventId(match[1]) !== null;
};

export const savePendingEventPath = (path: string): boolean => {
  if (typeof sessionStorage === 'undefined' || !isValidEventPath(path)) {
    return false;
  }

  sessionStorage.setItem(PENDING_EVENT_PATH_KEY, path);
  return true;
};

export const saveCurrentEventPath = (): boolean => {
  return typeof window !== 'undefined' && savePendingEventPath(window.location.pathname);
};

export const getPendingEventPath = (): string | null => {
  if (typeof sessionStorage === 'undefined') {
    return null;
  }

  const path = sessionStorage.getItem(PENDING_EVENT_PATH_KEY);
  if (!path || !isValidEventPath(path)) {
    clearPendingEventPath();
    return null;
  }

  return path;
};

export const consumePendingEventPath = (): string | null => {
  const path = getPendingEventPath();
  clearPendingEventPath();
  return path;
};

export const clearPendingEventPath = (): void => {
  if (typeof sessionStorage === 'undefined') {
    return;
  }

  sessionStorage.removeItem(PENDING_EVENT_PATH_KEY);
};
